<script setup>
import { computed } from 'vue'
import { Head, usePage, Link } from '@inertiajs/vue3'
import { useI18n } from 'vue-i18n'
import PartnersLayout from '@/Layouts/PartnersLayout.vue'

defineOptions({ layout: PartnersLayout })

const { t } = useI18n()
const page = usePage()
const base = computed(() => page.props.base || '')
defineProps({ types: { type: Array, default: () => [] } })
</script>

<template>
  <Head><title>{{ t('partners.index.head_title') }}</title></Head>
  <h1 class="p-title">
    {{ t('partners.index.title') }}
  </h1>
  <p class="p-lede">
    {{ t('partners.index.lede') }}
  </p>
  <div class="p-types">
    <Link
      v-for="ty in types"
      :key="ty"
      :href="`${base}/register?type=${ty}`"
      class="p-type"
    >
      <span class="p-type__name">{{ t(`partners.types.${ty}.name`) }}</span>
      <span class="p-type__desc">{{ t(`partners.types.${ty}.tagline`) }}</span>
    </Link>
  </div>
</template>

<style scoped>
.p-title { font-size: 1.25rem; font-weight: 700; color: var(--ink); margin: 0 0 0.5rem; }
.p-lede { color: var(--inkSoft); margin: 0 0 1.25rem; font-size: 0.9375rem; line-height: 1.5; }
.p-types { display: grid; gap: 0.625rem; }
.p-type { display: flex; flex-direction: column; gap: 0.15rem; padding: 0.875rem 1rem; border: 1px solid var(--line); border-radius: 0.75rem; background: var(--surface); text-decoration: none; transition: border-color 150ms ease, transform 150ms ease; }
.p-type:hover { border-color: color-mix(in oklch, var(--accent) 60%, var(--line)); transform: translateY(-1px); }
.p-type__name { font-weight: 600; color: var(--ink); }
.p-type__desc { font-size: 0.8125rem; color: var(--muted); }
</style>
